module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-默认图标-用户.8111b.png";